export default {"src":"/_next/static/media/frontend-rewards.cb3ca62b.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};